/**
 * 这是web自己定义的uid,只是为了大概记录uv，不是真实的uid
 * @returns string 随机16位字符串
 */

export function getWebUid() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomValues = new Uint32Array(16);
  crypto.getRandomValues(randomValues);
  const resultUid = Array.from(randomValues)
  .map(value => chars[value % chars.length])
  .join('');
  sessionStorage.setItem('web_uid', resultUid);
  return resultUid;
}